import { Modal, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useState } from "react";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { del, post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import { ICustoSchema, IPlanoERPSchema } from "../../Interfaces/financeiro/financeiro";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
interface I_aux {
    list: ICustoSchema[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<ICustoSchema[]>>,
    set_obj_new: React.Dispatch<React.SetStateAction<ICustoSchema | undefined>>,
    obj_new: ICustoSchema | undefined,
    obj_financeiro: IPlanoERPSchema | undefined,
    set_obj_new_financeiro: React.Dispatch<React.SetStateAction<IPlanoERPSchema | undefined>>,

}

export const Modaladdcustos: React.FC<I_aux> = ({
    list,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list,
    set_obj_new,
    obj_new,
    obj_financeiro,
    set_obj_new_financeiro,

}) => {
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [campo_obrigatorio_categoria, set_campo_obrigatorio_categoria] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes_custos, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_custos] = useState<boolean>(false);

    const [error_quantidade, set_error_quantidade] = useState<boolean>(false);
    const [error_preco_unitario, set_error_preco_unitario] = useState<boolean>(false);
    const [error_valor_iva, set_error_valor_iva] = useState<boolean>(false);
    const [error_taxa_iva, set_error_taxa_iva] = useState<boolean>(false);

    const handler_add = async () => {

        if (obj_new?.categoria === undefined || obj_new?.categoria === '') {
            set_campo_obrigatorio_categoria(true)

        } else {

            try {
                setIsLoading(true);
                let res = await post(auth.token.cookie_token, 'api/plano-erp/' + obj_financeiro?.id_plano + '/custos/new', {
                    payload: {
                        categoria: obj_new?.categoria === undefined ? '' : obj_new?.categoria,
                        descricao: obj_new?.descricao === undefined ? '' : obj_new?.descricao,
                        quantidade: obj_new?.quantidade === undefined ? 0 : obj_new?.quantidade,
                        unidade: obj_new?.unidade === undefined ? '' : obj_new?.unidade,
                        preco_unitario: obj_new?.preco_unitario === undefined ? 0 : obj_new?.preco_unitario?.toString().replace(',', '.'),
                        data_prevista: obj_new?.data_prevista === undefined ? null : obj_new?.data_prevista,
                        data_realizada: obj_new?.data_realizada === undefined ? null : obj_new?.data_realizada,
                        estado: obj_new?.estado === undefined ? '' : obj_new?.estado,
                        documento_ref: obj_new?.documento_ref === undefined ? null : obj_new?.documento_ref,
                        tipo_documento_externo: obj_new?.tipo_documento_externo === undefined ? '' : obj_new?.tipo_documento_externo,
                        serie: obj_new?.serie === undefined ? '' : obj_new?.serie,
                        data_documento: obj_new?.data_documento === undefined ? null : obj_new?.data_documento,
                        valor_iva: obj_new?.valor_iva === undefined ? 0 : obj_new?.valor_iva?.toString().replace(',', '.'),
                        taxa_iva: obj_new?.taxa_iva === undefined ? 0 : obj_new?.taxa_iva?.toString().replace(',', '.'),

                    }
                });
                if (list === undefined || list.length === 0) {
                    set_list([res.data.result])
                    set_obj_new_financeiro((old: any) => ({
                        ...old,
                        custos: [res.data.result]
                    }))

                } else {
                    set_list((old: any) => [...old, res.data.result])
                    set_obj_new_financeiro((old: any) => ({
                        ...old,
                        custos: [...(old?.custos || []), res.data.result]
                    }))

                }
                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_add", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }
    const handler_edit = async () => {

        if (obj_new?.categoria === undefined || obj_new?.categoria === '') {
            set_campo_obrigatorio_categoria(true)


        } else {

            try {
                setIsLoading(true);
                let res = await put(auth.token.cookie_token, 'api/plano-erp/custos/' + obj_new?.id_custo, {
                    payload: {
                        id_custo: obj_new?.id_custo === undefined ? 0 : obj_new?.id_custo,
                        categoria: obj_new?.categoria === undefined ? '' : obj_new?.categoria,
                        descricao: obj_new?.descricao === undefined ? '' : obj_new?.descricao,
                        quantidade: obj_new?.quantidade === undefined ? 0 : obj_new?.quantidade,
                        unidade: obj_new?.unidade === undefined ? '' : obj_new?.unidade,
                        preco_unitario: obj_new?.preco_unitario === undefined ? 0 : obj_new?.preco_unitario?.toString().replace(',', '.'),
                        data_prevista: obj_new?.data_prevista === undefined ? null : obj_new?.data_prevista,
                        data_realizada: obj_new?.data_realizada === undefined ? null : obj_new?.data_realizada,
                        estado: obj_new?.estado === undefined ? '' : obj_new?.estado,
                        documento_ref: obj_new?.documento_ref === undefined ? null : obj_new?.documento_ref,
                        tipo_documento_externo: obj_new?.tipo_documento_externo === undefined ? '' : obj_new?.tipo_documento_externo,
                        serie: obj_new?.serie === undefined ? '' : obj_new?.serie,
                        data_documento: obj_new?.data_documento === undefined ? null : obj_new?.data_documento,
                        valor_iva: obj_new?.valor_iva === undefined ? 0 : obj_new?.valor_iva?.toString().replace(',', '.'),
                        taxa_iva: obj_new?.taxa_iva === undefined ? 0 : obj_new?.taxa_iva?.toString().replace(',', '.'),


                    }
                });

                let aux_list = list.map((el) => {
                    if (el.id_custo === obj_new.id_custo) {
                        return res.data.result
                    } else {
                        return el
                    }
                })

                set_list(aux_list)
                set_obj_new_financeiro((old: any) => ({
                    ...old,
                    custos: aux_list
                }))


                setMessage(operacao_sucesso)
                setOpenSnackSuccess(true);
                setIsLoading(false);
                func_reset_all()

            } catch (error) {
                func_print("handler_edit", error, true);
                setMessage(operacao_erro)
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)
        if (name === 'quantidade') {
            if (/[a-zA-Z]/.test(value)) {
                set_error_quantidade(true)
            } else {
                set_error_quantidade(false)
            }
        }
        if (name === 'preco_unitario') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_preco_unitario(true)
            } else {
                set_error_preco_unitario(false)
            }
        }
        if (name === 'valor_iva') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_valor_iva(true)
            } else {
                set_error_valor_iva(false)
            }
        }
        if (name === 'taxa_iva') {
            if (!/^(\d+([.,]\d+)?)$/.test(value)) {
                set_error_taxa_iva(true)
            } else {
                set_error_taxa_iva(false)
            }
        }
        set_obj_new((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    }


    const func_reset_all = () => {
        set_obj_new(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_campo_obrigatorio_categoria(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);
        set_error_quantidade(false)
        set_error_preco_unitario(false)
        set_error_valor_iva(false)
        set_error_taxa_iva(false)

    }

    const handle_delete_custos = async () => {

        try {
            setIsLoading(true);
            await del(auth.token.cookie_token, `/api/plano-erp/custos/${obj_new?.id_custo}`);
            list.splice(list.findIndex((custo) => custo.id_custo === obj_new?.id_custo), 1);
            set_obj_new(undefined);
            func_reset_all()
            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_custos(false)
            setMessage(operacao_sucesso);
            setOpenSnackSuccess(true);
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_custos", error, true);
            setIsLoading(false);
            if ((error as any)?.response?.data?.message) {
                setMessage((error as any).response.data.message);
            } else {
                setMessage(operacao_erro);
            }
            setOpenSnackError(true);
        }
    };
    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-1 border-b border-gray-100">

                <div></div>

                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                        }
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                            <div className="flex items-center justify-between pl-5 w-full mb-4 pr-4">

                                <div className="grid grid-cols gap-2 ">

                                    <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                                        {
                                            flag_open_modal_edit === true ? 'Editar Custo' :
                                                flag_open_modal_ver_mais === true ? 'Detalhes do Custo' :
                                                    'Adicionar Custo'
                                        }
                                    </h2>
                                </div>


                                {
                                    flag_open_modal_add === false && flag_open_modal_edit === false ?
                                        <div className="flex justify-between gap-2">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_flag_open_modal(true);
                                                    set_flag_open_modal_edit(true);
                                                    set_flag_open_modal_add(false);
                                                    set_flag_open_modal_ver_mais(false)

                                                }}
                                                className="inline-flex items-center justify-center w-12 h-12 rounded-xl text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <EditIcon sx={{ fontSize: 18 }} />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_custos(true);
                                                }}
                                                className="inline-flex items-center justify-center w-12 h-12 rounded-xl text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <DeleteIcon sx={{ fontSize: 18 }} />
                                            </button>
                                        </div>
                                        : <></>
                                }
                            </div>

                            <div className="flex flex-col gap-6 w-full p-5 rounded-xl bg-gray-50/80">
                                {/* row 1: Designacao, Tipo, Localizacao, Stock minimo */}
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Categoria</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.categoria || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Categoria'
                                                            name="categoria"
                                                            error={campo_obrigatorio_categoria}
                                                            helperText={campo_obrigatorio_categoria ? 'Campo obrigatório' : ''}
                                                            value={obj_new?.categoria === undefined ? '' : obj_new?.categoria}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Descrição</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.descricao || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Descrição'
                                                            name="descricao"
                                                            value={obj_new?.descricao === undefined ? '' : obj_new?.descricao}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Quantidade</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.quantidade || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Quantidade'
                                                            name="quantidade"
                                                            value={obj_new?.quantidade === undefined ? '' : obj_new?.quantidade}
                                                            onChange={onInputChange}
                                                            error={error_quantidade}
                                                            helperText={error_quantidade ? 'A quantidade não pode conter letras' : ''}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Unidade</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.unidade || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Unidade'
                                                            name="unidade"
                                                            value={obj_new?.unidade === undefined ? '' : obj_new?.unidade}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                </div>
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Preço Unitário</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.preco_unitario || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Preço Unitário'
                                                            name="preco_unitario"
                                                            error={error_preco_unitario}
                                                            helperText={error_preco_unitario ? 'Insira um valor numérico' : ''}
                                                            value={obj_new?.preco_unitario === undefined ? '' : obj_new?.preco_unitario}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Data Prevista</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.data_prevista || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?

                                                    <div className="w-full">
                                                        <TextField
                                                            variant="outlined"
                                                            label="Data Prevista"
                                                            name="data_prevista"
                                                            type="date"
                                                            value={obj_new?.data_prevista === undefined ? '' : obj_new?.data_prevista}

                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new((old: any) => ({
                                                                    ...old,
                                                                    'data_prevista': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Data Realizada</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.data_realizada || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?

                                                    <div className="w-full">
                                                        <TextField
                                                            variant="outlined"
                                                            label="Data Realizada"
                                                            name="data_realizada"
                                                            type="date"
                                                            value={obj_new?.data_realizada === undefined ? '' : obj_new?.data_realizada}

                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new((old: any) => ({
                                                                    ...old,
                                                                    'data_realizada': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    : <></>}
                                    </div>

                                </div>
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Estado</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.estado || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Estado'
                                                            name="estado"
                                                            value={obj_new?.estado === undefined ? '' : obj_new?.estado}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Documento Ref.</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.documento_ref || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Documento Ref.'
                                                            name="documento_ref"
                                                            value={obj_new?.documento_ref === undefined ? '' : obj_new?.documento_ref}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Tipo Documento Externo</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.tipo_documento_externo || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Tipo Documento Externo'
                                                            name="tipo_documento_externo"
                                                            value={obj_new?.tipo_documento_externo === undefined ? '' : obj_new?.tipo_documento_externo}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>

                                </div>
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Serie</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.serie || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Serie'
                                                            name="serie"
                                                            value={obj_new?.serie === undefined ? '' : obj_new?.serie}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Data Documento</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.data_documento || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?

                                                    <div className="w-full">
                                                        <TextField
                                                            variant="outlined"
                                                            label="Data Documento"
                                                            name="data_documento"
                                                            type="date"
                                                            value={obj_new?.data_documento === undefined ? '' : obj_new?.data_documento}

                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                                set_flag_editado(true)

                                                                set_obj_new((old: any) => ({
                                                                    ...old,
                                                                    'data_documento': event.target.value,
                                                                }));

                                                            }}
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div>
                                                    : <></>}
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Valor IVA</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.valor_iva || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Valor IVA'
                                                            name="valor_iva"
                                                            error={error_valor_iva}
                                                            helperText={error_valor_iva ? 'Insira um valor numérico' : ''}
                                                            value={obj_new?.valor_iva === undefined ? '' : obj_new?.valor_iva}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>

                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Taxa IVA</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.taxa_iva || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true || flag_open_modal_add === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Taxa IVA'
                                                            name="taxa_iva"
                                                            error={error_taxa_iva}
                                                            helperText={error_taxa_iva ? 'Insira um valor numérico' : ''}
                                                            value={obj_new?.taxa_iva === undefined ? '' : obj_new?.taxa_iva}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                </div>

                            </div>
                            {flag_open_modal_ver_mais === true ? <></> :

                                <div className="p-5 flex justify-end w-full pt-4">
                                    <button
                                        type="button"
                                        onClick={() => {


                                            if (obj_new?.categoria === undefined || obj_new.categoria === '') {
                                                set_campo_obrigatorio_categoria(true);
                                            } else {

                                                set_campo_obrigatorio_categoria(false);
                                                if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                    handler_edit()
                                                } else if (flag_open_modal_add === true) {
                                                    handler_add()
                                                }
                                            }
                                        }}
                                        className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                    >
                                        Guardar Informação
                                    </button>
                                </div>
                            }



                        </div>


                    </>
            }
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes_custos}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_custos(false)}
                onConfirm={() => handle_delete_custos()}
                message={'Deseja eliminar o registo?'}

            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
        </div>



    </Modal >)

}
